export enum STEPS {
    APP_SELECTION = 'app-selection',
}